import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[uiAutocompleteValue]',
})
export class AutocompleteValueDirective<ValueType> {
  templateRef = inject<
    TemplateRef<{
      $implicit: ValueType;
    }>
  >(TemplateRef);
}
